/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { injectIntl } from 'react-intl';
import {
  Panel,
  Table,
  Button,
  OverlayTrigger,
  Tooltip,
  Collapse,
  Well,
} from 'react-bootstrap';
import gatewayActions from 'loraactions/gateway';
import IntlMsg from 'lorautils/intl/IntlMsg';
import DeleteModal from 'loracoms/DeleteModal';
import GatewayModal from 'loracoms/GatewayModal';
import ShowIf from 'loracoms/ShowIf';
import callAPI from '@/api/callAPI';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.any.isRequired,
  getAppGateway: PropTypes.func.isRequired,
  gatewayState: PropTypes.object.isRequired,
  appId: PropTypes.string.isRequired,
};

class GatewayList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      checked: [],
      showModal: false,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.gatewayview');
  }

  componentWillMount() {
    const { appId, getAppGateway } = this.props;
    getAppGateway(appId);
  }

  componentWillReceiveProps(nextProps) {
    const { gatewayState: { data } } = nextProps;
    if (data) {
      let list = _.map(data.list, l => ({
        ...l, isNew: false, status: this.getStatus(l),
      }));
      list = _.sortBy(list, li => li.status.connected).reverse();
      this.setState({ list });
    }
  }

  componentWillUnmount() {
    this.isNew = false;
  }

  getStatus(gw) {
    const disconnected = (
      <span>
        <i className={`fa fa-circle-o ${styles.disconnected}`} />
        {' '}
        {this.intlMsg.msg('status.disconnected')}
      </span>
    );
    const connected = (
      <span>
        <i className={`fa fa-circle ${styles.connected}`} />
        {' '}
        {this.intlMsg.msg('status.connected')}
      </span>
    );

    if (_.isNil(gw.lastOn)) {
      return { connected: false, content: disconnected };
    }
    if (_.isNil(gw.lastOff)) {
      return { connected: true, content: connected };
    }
    const onts = new Date(gw.lastOn).valueOf();
    const offts = new Date(gw.lastOff).valueOf();
    if (onts > offts) {
      return { connected: true, content: connected };
    }
    return { connected: false, content: disconnected };
  }

  handleOnSuccess(gateway) {
    const { appId } = this.props;
    const gws = _.map(gateway, gw => gw.id);
    if (gws.length) {
      callAPI({
        endpoint: `/lora/apps/${appId}/gws`,
        method: 'POST',
        body: gws,
      }).then(() => {
        let { list } = this.state;
        list = _.concat(_.map(gateway, gw =>
          ({ ...gw, isNew: true, status: this.getStatus(gw) })),
          list,
        );
        this.setState({ list });
      }).catch(() => {});
    }
    this.setState({ showModal: false });
  }

  handleDeleteGateway() {
    const { deleteGateway = {}, list } = this.state;
    if (deleteGateway.id) {
      callAPI({
        endpoint: `/lora/apps/${this.props.appId}/gws/${deleteGateway.id}`,
        method: 'DELETE',
      }).then(() => {
        this.setState({
          list: _.filter(list, l => l.id !== deleteGateway.id),
          showDeleteModal: false,
        });
      }).catch(() => {});
    }
  }

  render() {
    const {
      showModal,
      list,
      showDeleteModal = false,
      deleteGateway = {},
      showHelp = false,
    } = this.state;
    const { appId } = this.props;
    const header = (
      <div>
        {this.intlMsg.msg('gatewaylist.header')}
        <Button
          bsStyle="aisz-success"
          onClick={() => this.setState({ showModal: true })}
          className={styles.marginLm}
        >
          {this.intlMsg.msg('gatewaylist.chose')}
        </Button>
        <Link
          className={`glyphicons glyphicons-question-sign ${styles.help}`}
          onClick={() => this.setState({ showHelp: !showHelp })}
        />
      </div>
    );
    const tooltip = <Tooltip id="tooltip-delete">{this.intlMsg.msg('gatewaylist.delete')}</Tooltip>;
    const rows = _.map(list, l => (
      <tr key={l.id} className={l.isNew ? styles.new : ''}>
        <td>{l.name}</td>
        <td>
          <Link to={`/gateway/detail/${l.id}`}>
            {l.mac}
          </Link>
        </td>
        <td>{l.status.content}</td>
        <td>{l.city}</td>
        <td>{l.area}</td>
        <td className="text-center">
          <OverlayTrigger placement="top" overlay={tooltip}>
            <Link
              className={styles.delete}
              onClick={() => {
                this.setState({
                  showDeleteModal: true,
                  deleteGateway: l,
                });
              }}
            >
              <span className="halflings halflings-trash" />
            </Link>
          </OverlayTrigger>
        </td>
      </tr>
    ));
    return (
      <div>
        <Panel
          bsStyle="aisz-white"
          header={header}
        >
          <Collapse in={showHelp}>
            <Well bsClass="aisz-well-light">
              <div>
                <p>
                  {this.intlMsg.msg('gatewaylist.help0')}
                </p>
                <ul>
                  <li>{this.intlMsg.msg('gatewaylist.help1')}</li>
                  <li>{this.intlMsg.msg('gatewaylist.help2')}</li>
                  <li>{this.intlMsg.msg('gatewaylist.help3')}</li>
                  <li>{this.intlMsg.msg('gatewaylist.help4')}</li>
                </ul>
                <p>
                  {this.intlMsg.msg('gatewaylist.help5')}
                </p>
              </div>
            </Well>
          </Collapse>
          <Table
            className="aisz-table-light"
            striped
            hover
            bordered
            responsive
          >
            <thead>
            <tr>
              <th>{this.intlMsg.msg('gatewaylist.name')}</th>
              <th>{this.intlMsg.msg('gatewaylist.mac')}</th>
              <th>{this.intlMsg.msg('gatewaylist.connect')}</th>
              <th>{this.intlMsg.msg('gatewaylist.city')}</th>
              <th>{this.intlMsg.msg('gatewaylist.area')}</th>
              <th className="text-center">{this.intlMsg.msg('gatewaylist.operation')}</th>
            </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
          <ShowIf if={list.length === 0}>
            <div className={styles.noData}>
              {this.intlMsg.msg('gatewaylist.nodata')}
            </div>
          </ShowIf>
          <GatewayModal
            appId={appId}
            showModal={showModal}
            onHide={() => this.setState({ showModal: false })}
            onSuccess={gw => this.handleOnSuccess(gw)}
            disableCheck={list}
          />
          <DeleteModal
            showModal={showDeleteModal}
            onCancel={() => this.setState({ showDeleteModal: false })}
            onConfirm={() => this.handleDeleteGateway()}
            headerText={this.intlMsg.msg('gatewaylist.delheader')}
            text={`${this.intlMsg.msg('gatewaylist.deltext')}${deleteGateway.name}(${deleteGateway.id})?`}
          />
        </Panel>
      </div>
    );
  }
}

GatewayList.propTypes = propTypes;

const mapStateToProps = state => ({
  gatewayState: state.gateway.getAppGateway,
});

const mapDispatchToProps = {
  getAppGateway: gatewayActions.getAppGateway,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(GatewayList));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DetailView/coms/GatewayList/index.jsx